import { Suspense, lazy } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import NotFoundPage from '../common/page/fallback/NotFoundPage';
import DiagramBpmnIndex from '../modules/BpmnIoDiagram/Index';
import Callback from '../modules/callback/callback';
import TechnologyDataLandscape from '../modules/EnterpriseContext';
import ProtectedRoute, { ModuleProtectedRoute } from './ProtectedRoute';
import Loader from '../common/components/Loader';
import DataXPLR from '../modules/DataXPLR';

const Login = lazy(() => import('../modules/SignIn'));
const SimulationXPLR = lazy(() => import('../modules/SimulationXPLR'));
//Hide solutionXPLR for now
// const SolutionXPLR = lazy(() => import('../modules/SolutionXPLR'));
const TaxonomyXPLR = lazy(() => import('../modules/TaxonomyXPLR'));
const PortfolioXPLR = lazy(() => import('../modules/PortfolioXPLR'));
const FunctionalDesignXPLR = lazy(() => import('../modules/FunctionalDesignXPLR'));
const NewSolutionXPLR = lazy(() => import('../modules/NewSolutionXPLR'));
const SolutionApproval = lazy(() => import('../modules/SolutionApproval/SolutionApproval'));
const NewIdeationXPLR = lazy(() => import('../modules/NewIdeationXPLR'));
const IdeationCOI = lazy(() => import('../modules/IdeationCOI'));
const DashboardXPLR = lazy(() => import('../modules/Dashboard/Index'));
const DashboardDetails = lazy(() => import('../modules/Dashboard/dashboardDetails'));
const Router: React.FC = () => {
  const location = useLocation();

  return (
    <Suspense fallback={<Loader message="Loading" />}>
      <Routes>
        {/* Protected routes parent */}
        <Route element={<ProtectedRoute />}>
          {/* Module-protected routes */}
          <Route
            path="/"
            element={
              <ModuleProtectedRoute path="/">
                <DashboardXPLR key={location.key} />
              </ModuleProtectedRoute>
            }
          />
          <Route path="/opportunity/:id" element={<DashboardDetails key={location.key} />} />
          <Route path="/industry" element={<SimulationXPLR />} />
          <Route
            path="/process"
            element={
              <ModuleProtectedRoute path="/process">
                <SimulationXPLR key={location.key} />
              </ModuleProtectedRoute>
            }
          />
          <Route path="/process-xplr" element={<TaxonomyXPLR key={location.key} />} />
          <Route
            path="/ideation-xplr"
            element={
              <ModuleProtectedRoute path="/ideation-xplr">
                <NewIdeationXPLR />
              </ModuleProtectedRoute>
            }
          />
          <Route path="/ideation-coi/:id" element={<IdeationCOI />} />
          <Route
            path="/solution-xplr"
            element={
              <ModuleProtectedRoute path="/solution-xplr">
                <NewSolutionXPLR key={location.key} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/portfolio"
            element={
              <ModuleProtectedRoute path="/portfolio">
                <PortfolioXPLR />
              </ModuleProtectedRoute>
            }
          />
          <Route path="/design-nexus" element={<FunctionalDesignXPLR />} />
          <Route path="/diagram" element={<DiagramBpmnIndex />} />
          <Route path="/enterprise-context" element={<TechnologyDataLandscape />} />
          <Route path="/approval-requests" element={<SolutionApproval />} />
          <Route
            path="/data-xplr"
            element={
              <ModuleProtectedRoute path="/data-xplr">
                <DataXPLR />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/data-xplr/:id"
            element={
              <ModuleProtectedRoute path="/data-xplr">
                <DataXPLR />
              </ModuleProtectedRoute>
            }
          />
        </Route>

        {/* Public route */}
        <Route path=":tenantSlug/login" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<Callback />} />

        {/* Catch-all */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};

export default Router;
